import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Launcher mode's switch (Settings → Launcher mode). OFF by default: Home is then exactly as it
 * was. ON, Home starts with the launcher rows (owner, 2026-10-20: "Home becomes it, when on").
 * Per device, not per profile: it is about the box.
 */
export interface LauncherStore {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
}

export const useLauncher = create<LauncherStore>()(
  persist(
    (set) => ({
      enabled: false,
      setEnabled: (enabled) => set({ enabled }),
    }),
    { name: "slique-launcher" },
  ),
);
